import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiCreditCard, FiUser, FiUsers, FiSettings, FiGrid, FiShare2 } from 'react-icons/fi';
import { IoScanOutline } from 'react-icons/io5';
import './Home.css';

const Home = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [avatarError, setAvatarError] = useState(false);

  const displayName = user?.first_name && user?.last_name
    ? `${user.first_name} ${user.last_name}`
    : user?.name || 'User';
  const displayRole = user?.job_title || 'CEO';
  const displayCompany = user?.company || 'Omni';
  const avatarUrl = user?.avatar_url;

  const handleShare = async () => {
    const shareUrl = `${window.location.origin}/my-card`;
    if (navigator.share) {
      try {
        await navigator.share({ title: 'My OMNI Card', url: shareUrl });
      } catch (_) {
        navigator.clipboard?.writeText(shareUrl);
      }
    } else {
      navigator.clipboard?.writeText(shareUrl);
    }
  };

  const shortcuts = [
    {
      id: 'my-card',
      title: 'My Card',
      subtitle: 'View & Edit',
      icon: <FiCreditCard size={22} />,
      action: () => navigate('/my-card'),
      variant: 'dark',
    },
    {
      id: 'qr',
      title: 'My QR',
      subtitle: 'Share Code',
      icon: <FiGrid size={22} />,
      action: () => navigate('/my-card'),
      variant: 'gray',
    },
    {
      id: 'scan',
      title: 'Scan',
      subtitle: 'Scan QR Code',
      icon: <IoScanOutline size={22} />,
      action: () => navigate('/scan'),
      variant: 'light',
    },
    {
      id: 'contacts',
      title: 'Contacts',
      subtitle: 'Saved Cards',
      icon: <FiUsers size={22} />,
      action: () => navigate('/contacts'),
      variant: 'light',
    },
    {
      id: 'share',
      title: 'Share',
      subtitle: 'Send Card Link',
      icon: <FiShare2 size={22} />,
      action: handleShare,
      variant: 'light',
    },
  ];

  return (
    <div className="home-container">
      <div className="home-content">

        {/* Header */}
        <p className="home-header-title">myOmni Card</p>

        {/* Profile Card Hero (matches mobile HomeScreen ProfileCard.png) */}
        <div className="home-hero-wrapper" onClick={() => navigate('/my-card')}>
          <div className="home-hero-card" style={{ backgroundImage: "url('/ProfileCard.png')" }}>
            <img src="/icons/logoLight.png" alt="OMNI" className="home-hero-logo" />
            <div className="home-avatar-ring">
              <div className="home-avatar-inner">
                {avatarUrl && !avatarError ? (
                  <img
                    src={avatarUrl}
                    alt="Avatar"
                    className="home-avatar-img"
                    onError={() => setAvatarError(true)}
                  />
                ) : (
                  <div className="home-avatar-placeholder">
                    <FiUser size={52} color="#9AA3A8" />
                  </div>
                )}
              </div>
            </div>
            <div className="home-hero-divider" />
            <div className="home-hero-info">
              <h2 className="home-hero-name">{displayName}</h2>
              <p className="home-hero-role">{displayRole} @ {displayCompany}</p>
            </div>
          </div>
        </div>

        {/* Shortcuts Grid */}
        <div className="shortcuts-grid">
          {shortcuts.map((shortcut) => (
            <ShortcutTile key={shortcut.id} {...shortcut} />
          ))}
        </div>

        {/* Settings row */}
        <button className="home-settings-btn" onClick={() => navigate('/settings')}>
          <FiSettings size={18} />
          <span>Settings</span>
        </button>

      </div>
    </div>
  );
};

const ShortcutTile = ({ title, subtitle, icon, action, variant }) => (
  <div className={`shortcut-tile shortcut-${variant}`} onClick={action}>
    <div className="shortcut-header">
      <div className="shortcut-icon-badge">{icon}</div>
      <div className="shortcut-title">{title}</div>
    </div>
    <div className="shortcut-subtitle">{subtitle}</div>
  </div>
);

export default Home;
